module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.user) ? _c('header', {
    staticClass: "fixed"
  }, [_c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/andalepide.svg",
      "alt": "Andalepide"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbar-collapse"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/suscripcion"
    }
  }, [_c('a', [_vm._v("SUSCRIPCIÓN")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/ondemand"
    }
  }, [_c('a', [_vm._v("ON-DEMAND")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/partners"
    }
  }, [_c('a', [_vm._v("PARTNERS")])]), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "tag": "li",
      "to": "/login",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "btn-login"
  }, [_vm._v("INGRESAR")])])], 1)])])])]) : [_c('div', {
    staticClass: "user-sesion"
  }, [(_vm.user.roles[0] === 'admincliente' || _vm.user.roles[0] === 'user') ? _c('header', [(!_vm.user.needsToAnswerCampaign) ? _c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar-collapse",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Menu")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/andalepide.svg",
      "alt": "Andalepide"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "head-cart"
  }, [(_vm.user.roles[0] === 'admincliente' || _vm.user.roles[0] === 'user') ? [_c('a', {
    staticClass: "total visible-lg visible-md show-aside-cart",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toggleCarrito
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.totalCarrito))]), _vm._v(" "), _c('i', {
    staticClass: "icon-kart"
  })]), _vm._v(" "), _c('a', {
    staticClass: "hidden-lg hidden-md",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.irACheckOut($event)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.totalCarrito))]), _vm._v(" "), _c('i', {
    staticClass: "icon-kart"
  })])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbar-collapse"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/hacerpedido"
    }
  }, [_c('a', [_vm._v("MENÚ")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/mispedidos",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("MIS PEDIDOS")])]), _vm._v(" "), (_vm.user.roles[0] === 'admincliente') ? _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("PANEL ADMINISTRACIÓN "), _c('span', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/adminpedidos"
    }
  }, [_c('a', [_vm._v("Pedidos")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/usuarios"
    }
  }, [_c('a', [_vm._v("Usuarios")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/historialempresa"
    }
  }, [_c('a', [_vm._v("Historial Empresa")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/usuarios/liquidaciones"
    }
  }, [_c('a', [_vm._v("Liquidaciones")])])], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.user.displayName) + " "), _c('span', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/perfil"
    }
  }, [_c('a', [_vm._v("Perfil")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/logout"
    }
  }, [_c('a', [_vm._v("Salir")])])], 1)])], 1)])])]) : _c('nav', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar-collapse",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Menu")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/andalepide.svg",
      "alt": "Andalepide"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "head-cart"
  }), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbar-collapse"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.user.displayName) + " "), _c('span', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/logout"
    }
  }, [_c('a', [_vm._v("Salir")])])], 1)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.user.roles[0] === 'restaurante') ? _c('header', {
    staticClass: "static"
  }, [_c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar-collapse",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Menu")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/andalepide.svg",
      "alt": "Andalepide"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbar-collapse"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("PEDIDOS Y ENTREGAS "), _c('span', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/gestorentregas"
    }
  }, [_c('a', [_vm._v("Gestor de Entregas")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/historicoentregas"
    }
  }, [_c('a', [_vm._v("Historial Empresa")])])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("RESTAURANTE "), _c('span', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/platos"
    }
  }, [_c('a', [_vm._v("Platos")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/asignarmenu"
    }
  }, [_c('a', [_vm._v("Menus")])])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("LIQUIDACIONES "), _c('span', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/restaurante/liquidaciones"
    }
  }, [_c('a', [_vm._v("Liquidaciones")])])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/perfil"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.user.proveedorAsociado.razonSocial))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/logout"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-sign-out"
  })])])], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.user.roles[0] === 'root') ? _c('header', {
    staticClass: "static"
  }, [_c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar-collapse",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Menu")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/andalepide.svg",
      "alt": "Andalepide"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbar-collapse"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav pull-right"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/stats"
    }
  }, [_c('a', [_vm._v("Estadísticas")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/campaigns"
    }
  }, [_c('a', [_vm._v("Campañas")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/adminroot"
    }
  }, [_c('a', [_vm._v("Admin")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("LIQUIDACIONES "), _c('span', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/liquidaciones/clientes"
    }
  }, [_c('a', [_vm._v("Clientes")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/liquidaciones/proveedores"
    }
  }, [_c('a', [_vm._v("Proveedores")])])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/admingestorentregas"
    }
  }, [_c('a', [_vm._v("Pedidos")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/categorias"
    }
  }, [_c('a', [_vm._v("Categorias")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Parámetros "), _c('span', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "data-toggle": "tooltip",
      "rel": "tooltip",
      "data-placement": "bottom",
      "data-original-title": "Unidades de Medida",
      "title": "Unidades de Medida",
      "to": "/measureUnits"
    }
  }, [_c('a', [_vm._v("Unidades")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "data-toggle": "tooltip",
      "rel": "tooltip",
      "data-placement": "bottom",
      "data-original-title": "Notificaciones Automáticas",
      "title": "Notificaciones Automáticas",
      "to": "/notifications"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-whatsapp"
  }), _vm._v(" Notificaciones Automáticas")])])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/combos"
    }
  }, [_c('a', [_vm._v("Combos")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/proveedores"
    }
  }, [_c('a', [_vm._v("Proveedores")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/clientes"
    }
  }, [_c('a', [_vm._v("Clientes")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/perfil"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.user.displayName))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/repararpedidos"
    }
  }, [_c('a', [_vm._v("Reparar pedidos")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "active",
      "to": "/logout"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-sign-out"
  })])])], 1)])])])]) : _vm._e()])]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar-collapse",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Menu")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9bf19a74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar/NavIndex.vue
// module id = 1159
// module chunks = 5